<template>
<div class="page-content-wrapper">
  <div class="page-content role">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">角色</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <div id="search-bar" class="lp-flex-box search-bar-item">
      <input type="text" name="name" placeholder="输入名称查询" class="form-control" v-model="biz.name">
      <button type="button" class="btn blue" @click="search">查询 <i class="fa fa-search"></i></button>
      <button type="button" class="btn green" @click="detail(0)">新增角色 <i class="icon-plus m-icon-white"></i></button>
    </div>
    <br>
    <table class="table table-striped table-hover table-bordered table-condensed">
      <thead>
        <tr>
          <th width="20%" class="text_overflow">名称</th>
          <th class="text_overflow">角色编码</th>
          <th width="20%" class="text_overflow">创建日期</th>
          <th width="15%">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in biz.items">
          <td style="vertical-align:middle" class="text_overflow">{{item.description}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.name}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{dtFormat(item.create_time)}}</td>
          <td>
            <a href="javascript:void(0)" @click="detail(item.id)">详情</a>|
            <a href="javascript:void(0)" @click="remove(item.id)">删除</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="pager-bar">
      <pager :page-index="pageIndex" :page-size="pageSize" :total-count="totalCount" :action="query" @page-change="onPageChange"></pager>
    </div>
  </div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import Pager from '../fragment/Pager.vue'
import BootstrapModal from '../fragment/BootstrapModal.vue'
import RoleEdit from './RoleEdit.vue'
import {mapState} from 'vuex'
import mixins from '../../mixins/index'
import common from '../../lib/methods/common.js'
import {MSG_ID, SER_RESP_CODE} from '../../lib/constant.js'
export default {
  name: 'role',
  mixins: mixins,
  data () {
    return {
      biz: {
        items: [],
        name: ''
      },
      pageIndex: 1,
      pageSize: 500,
      totalCount: 0
    }
  },
  components: {
    BootstrapModal,
    RoleEdit,
    Pager
  },
  created () {
    window.emitter.on(MSG_ID.MSG_ROLE_SET_SUCCESS, (...args) => {
      this.query()
    })
  },
  mounted () {
    this.query()
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      this.resetPager()
      this.query()
    },
    query () {
      let that = this
      let reqdata = {page_index: this.pager.pageIndex, page_size: this.pageSize, account: this.uid(), name: this.biz.name}
      http.invoke('auth.pageRole', reqdata, function (data) {
        that.biz.items = data.content
        that.totalCount = data.total_count
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, RoleEdit, {title: '编辑角色', id: id})
    },
    remove (id) {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除角色定义', (data) => {
        let reqdata = {action: 2, id: id}
        http.invoke('auth.setRole', reqdata, (data) => {
          window.emitter.emit(MSG_ID.MSG_ROLE_SET_SUCCESS)
        }, (state) => {
          if (state.code !== 2000000) {
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
            return
          }
          switch (state.result) {
            case 1:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '角色正在被使用,不能删除')
              break
            default:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '登录失败')
          }
        })
      })
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.role {
  background-color: #fff;
}
.search-bar-item {
  flex-grow: 1;
}
#pager-bar {
  text-align: center;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// Role.vue?09bafffb